<template>
  <div class="label">
    <span class="name">{{name}}</span>
    <span class="value">{{value}}</span>
  </div>
</template>

<script>
  export default {
    name: "Label",
    props: ["name", "value"]
  }
</script>

<style lang="scss" scoped>
  .label {

    list-style: none;
    float: left;
    margin-right: 100px;
    font-size: 14px;
    color: #8d8b8b;
    width: 100%;
    line-height: 30px;
    margin-bottom: 5px;

    .value {
      padding-left: 10px;
      color: #000000;
      opacity: 0.85;
    }
  }
</style>
